import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { rootRoutes } from './config';

@NgModule({
    imports: [
        RouterModule.forRoot(rootRoutes),
    ],
    exports: [
        RouterModule,
    ],
    declarations: [],
})
export class AppRoutingModule { }
